import React from 'react';
import ModalWrapper from '../shared/ModalWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
function SimpleShareContentModal(_ref) {
  var data = _ref.data,
    onClose = _ref.onClose;
  return /*#__PURE__*/_jsx(ModalWrapper, {
    data: data,
    onClose: onClose
  });
}
export default SimpleShareContentModal;